import { useNavigate } from 'react-router-dom'

interface ClickableUserProps {
  userId: string
  userName: string
  className?: string
  onClick?: () => void
}

/**
 * Reusable component for displaying a clickable user name that navigates to their profile
 */
export function ClickableUser({ userId, userName, className = '', onClick }: ClickableUserProps) {
  const navigate = useNavigate()

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation() // Prevent parent click handlers
    if (onClick) {
      onClick()
    }
    navigate(`/profile/${userId}`)
  }

  return (
    <button
      onClick={handleClick}
      className={`hover:underline hover:text-amber-300 transition-colors duration-200 cursor-pointer ${className}`}
    >
      {userName}
    </button>
  )
}
